import { getSafeGateway } from '@tectonics/prs/core/gateway';
import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { es } from 'date-fns/locale';
import { formatDate } from '@tectonics/utils/date';
import voucher from '@tectonics/prs/voucher';
import i18n from 'i18next';

export interface ExpirationDetails {
  readonly weekDay: string;
  readonly formattedDate: string;
  readonly expireDate: string;
  readonly expireTime: string;
}

export function getSafeExpirationDatetime(incomingPayment: PendingIncomingPayment): string | null {
  const gateway = getSafeGateway(incomingPayment);
  return gateway['pix_expiration_datetime'];
}

export function getSafeExpirationDatetimeDebin(incomingPayment: PendingIncomingPayment): string {
  const expirationDatetime = incomingPayment['expire_date'];

  if(!expirationDatetime){
    throw new Error('Banktransfer: no expiration date and time in incoming payment');
  }

  return expirationDatetime;
}

export function getExpirationDetailsFromPayment(payment: PendingIncomingPayment): ExpirationDetails {
  const expirationDateTime = getSafeExpirationDatetimeDebin(payment);
  const weekDay = formatDate({ date: expirationDateTime, formatString: 'EEEE', locale: es });
  const expireDate = formatDate({ date: expirationDateTime, formatString: voucher.dueDateFormat });
  const formattedDate = formatDateToSpanish(expireDate);
  const expireTime = expirationDateTime.substring(11, 16);

  return { weekDay, formattedDate, expireDate, expireTime };
}

export function getExpireDateMessageFromPayment(payment: PendingIncomingPayment): string {
  const { weekDay, formattedDate, expireDate, expireTime } = getExpirationDetailsFromPayment(payment);

  return i18n.t('volcanes:payment-methods.banktransfer.debin.instructionTextExpiryTime', {
    weekDay:       weekDay,
    formattedDate: formattedDate,
    expireDate:    expireDate,
    expireTime:    expireTime,
  });
}

export function formatDateToSpanish(dateString: string): string {
  const [day, month] = dateString.split('/').map(Number);
  const monthsInSpanish = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  return `${day} de ${monthsInSpanish[month - 1]}`;
}
